<template>
  <v-container fill-height fluid class="primary custom-container-height">
    <v-col class="custom-height" xs="12" sm="12" md="12">
      <v-row wrap>
        <v-col xs="10" offset-xs="1" sm="10" offset-sm="1" md="8" offset-md="2">
          <div class="card-style rounded-card">
            <v-card-title class="title-style">
              <h4>Set Your New Password</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-form>
                <v-text-field ref="resetPassword" v-model="newPassword" :type="visible ? 'text' : 'password'"
                  label="Enter New Password" dense outlined :rules="passwordRules" :hide-details="true"
                  prepend-inner-icon="lock" :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="() => (visible = !visible)" @input="updatePasswordStrength"
                  @focus="showPasswordValidation = true"
                  @blur="showPasswordValidation = newPassword.length > 0"></v-text-field>

                <!-- Password Strength Indicator -->
                <div v-if="newPassword" class="mt-2 mb-2">
                  <v-progress-linear :value="passwordStrength.strength" :color="passwordStrength.color" height="6"
                    background-color="#e0e0e0" rounded></v-progress-linear>
                  <div class="d-flex justify-space-between align-center mt-1">
                    <span class="text-caption font-weight-medium" :style="{ color: passwordStrength.color }">
                      {{ passwordStrength.description }}
                    </span>
                    <span class="text-caption" style="opacity: .8;">
                      {{ passwordStrength.strength }}% - {{ passwordStrength.message }}
                    </span>
                  </div>
                </div>

                <!-- Password Validation Messages -->
                <div v-if="showPasswordValidation && newPassword.length > 0" class="mb-3">
                  <div v-if="passwordValidation.errors.length > 0" class="mb-2">
                    <div v-for="error in passwordValidation.errors" :key="error" class="text-caption text-error">
                      <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
                      {{ error }}
                    </div>
                  </div>
                  <div v-if="passwordValidation.warnings.length > 0">
                    <div v-for="warning in passwordValidation.warnings" :key="warning"
                      class="text-caption text-warning">
                      <v-icon small color="warning" class="mr-1">mdi-alert</v-icon>
                      {{ warning }}
                    </div>
                  </div>
                </div>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed @click="resetPassword">Save</v-btn>
            </v-card-actions>
          </div>
          <p class="text-center custom-footer">
            © {{ new Date().getFullYear() }} All rights reserved by GoDial
          </p>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="loaderDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import PasswordSecurity from "../js/password-security";

export default {
  data() {
    return {
      newPassword: "",
      visible: false,
      loaderDialog: false,
      passwordRules: [
        (v) => !!v || "This field is required.",
      ],
      passwordValidation: {
        isValid: false,
        errors: [],
        warnings: [],
        strength: 0,
      },
      passwordStrength: {
        strength: 0,
        description: '',
        color: '#f44336',
        message: ''
      },
      showPasswordValidation: false,
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT"]),
  },
  watch: {},
  created() { },
  methods: {
    updatePasswordStrength() {
      if (!this.newPassword) {
        this.passwordStrength = {
          strength: 0,
          description: '',
          color: '#f44336',
          message: ''
        };
        this.passwordValidation = {
          isValid: false,
          errors: [],
          warnings: [],
          strength: 0
        };
        return;
      }

      const validation = PasswordSecurity.validatePassword(this.newPassword);
      this.passwordValidation = validation;
      this.passwordStrength = {
        strength: validation.strength,
        description: PasswordSecurity.getStrengthDescription(validation.strength),
        color: PasswordSecurity.getStrengthColor(validation.strength),
        message: validation.errors.length > 0 ? validation.errors[0] :
          validation.warnings.length > 0 ? validation.warnings[0] :
            'Requirements met!'
      };
    },
    resetPassword(e) {
      const self = this;

      if (this.newPassword == "") {
        this.$swal({
          type: "error",
          text: "Please provide a password",
        });
        return;
      }

      const validation = PasswordSecurity.validatePassword(self.newPassword);
      if (!validation.isValid) {
        return this.$swal({
          type: "warning",
          text: validation.errors[0] || "Invalid password",
        });
      }

      self.loaderDialog = true;

      self.$http
        .post(
          `${this.ENDPOINT}/accounts/reset-password?access_token=${self.$route.query.token}`,
          { newPassword: self.newPassword }
        )
        .then(
          (response) => {
            self.loaderDialog = false;
            self.$router.replace({ path: "/" });
          },
          (error) => {
            self.loaderDialog = false;
            if (error && error.status == 0) {
              return self.$swal({ type: "error", text: "Connection Error" });
            }
            if (
              error &&
              error.body &&
              error.body.error &&
              error.body.error.message
            ) {
              return self.$swal({
                type: "error",
                text: error.body.error.message,
              });
            }
            return self.$swal({ type: "error", text: "Some error occured" });
          }
        );
    },
  },
};
</script>

<style>
/* .v-card {
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0),
    0 1px 3px 0 rgba(0, 0, 0, 0) !important;
  border-radius: 12px !important;
} */

.custom-height {
  min-height: 100%;
}

.custom-container-height {
  min-height: 100vh;
  background-image: linear-gradient(to right, #37cf37, #37cf37);
}

.custom-footer {
  color: white;
  margin-top: 2rem;
  font-weight: 500;
  font-family: Poppins, sans-serif;
}

.card-style {
  background-color: white;
}

.rounded-card {
  border-radius: 12px;
}

.title-style {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
